import { API_ERROR } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case API_ERROR:
      // console.log(action.payload);
      return { ...state, error: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Error.js